import { render, staticRenderFns } from "./toplu.vue?vue&type=template&id=97d54f44&scoped=true"
import script from "./toplu.vue?vue&type=script&lang=js"
export * from "./toplu.vue?vue&type=script&lang=js"
import style0 from "./toplu.vue?vue&type=style&index=0&id=97d54f44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97d54f44",
  null
  
)

export default component.exports